import { MainColor } from '../../palette';

export const getWorkstationTheme = () => {
  return {
    tasksList: {
      iconColor: 'navy60' satisfies MainColor as MainColor,
      selectedBackgroundColor: 'navy10' satisfies MainColor as MainColor,
    },
    duration: {
      default: 'forest50' satisfies MainColor as MainColor,
      overdue: 'rose50' satisfies MainColor as MainColor,
      border: 'coolGrey20' satisfies MainColor as MainColor,
    },
    statesColours: {
      sensorsBadge: {
        background: 'green30' satisfies MainColor as MainColor,
        text: 'green80' satisfies MainColor as MainColor,
      },
      default: {
        background: 'coolGrey5' satisfies MainColor as MainColor,
        text: 'navy80' satisfies MainColor as MainColor,
      },
      setup: {
        background: 'yellow20' satisfies MainColor as MainColor,
        text: 'yellow60' satisfies MainColor as MainColor,
      },
      production: {
        background: 'navy10' satisfies MainColor as MainColor,
        text: 'navy60' satisfies MainColor as MainColor,
      },
      idle: {
        background: 'coolGrey10' satisfies MainColor as MainColor,
        text: 'coolGrey60' satisfies MainColor as MainColor,
      },
      downtime: {
        background: 'red10' satisfies MainColor as MainColor,
        text: 'red60' satisfies MainColor as MainColor,
      },
      changeStatusModal: {
        icon: 'coolGrey60' satisfies MainColor as MainColor,
      },
    },
    report: {
      background: 'coolGrey5' satisfies MainColor as MainColor,
      sensorBackground: 'yellow5' satisfies MainColor as MainColor,
      border: 'coolGrey10' satisfies MainColor as MainColor,
      sensorBorder: 'yellow40' satisfies MainColor as MainColor,
      innerBorder: 'coolGrey30' satisfies MainColor as MainColor,
      text: 'navy95' satisfies MainColor as MainColor,
      header: 'coolGrey60' satisfies MainColor as MainColor,
      oksColor: 'green50' satisfies MainColor as MainColor,
      noksColor: 'red50' satisfies MainColor as MainColor,
    },
  };
};

export type WorkstationTheme = ReturnType<typeof getWorkstationTheme>;
